import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { openModal, closeModal } from "../../features/slices/modalSlice";
import { useLazyLaunchDemoGameQuery } from "../../features/api/publicApiSlice";
import * as Constant from "../../features/constant";
import { useEffect, useState } from "react";
import {
    useMediaQuery,
    useTheme,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Grid,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


const LaunchDemo = () => {
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [dialogData, setDialogData] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const location = useLocation();
    useEffect(() => {
        if (!dialogOpen) {
            const timeout = setTimeout(() => setDialogData(null), 1000);
            return () => clearTimeout(timeout);
        }
    }, [dialogOpen]);

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleDemo = () => {
        if (dialogData?.type === 'game') {
            getLaunchDemoGame({
                category: dialogData.game.category,
                type: dialogData.game.gameType,
                gameProductCode: dialogData.game.productCode,
                gameName: dialogData.game.name,
                isMobile: mobileView,
            });
        } else if (dialogData?.type === 'provider') {
            getLaunchDemoGame({
                category: dialogData.category,
                type: dialogData.provider.gameType,
                gameProductCode: dialogData.provider.name,
                gameName: dialogData.provider.gameItemName,
                isMobile: mobileView,
            });
        }
        setDialogOpen(false);
    };

    const [
        getLaunchDemoGame,
        {
            data: launchDemoGame,
            isFetching: isLaunchDemoGameFetching,
            isLoading: isLaunchDemoGameLoading,
            isError: islaunchDemoGameError,
            isSuccess: isLaunchDemoGameSuccess,
            error: launchDemoGameError,
        },
    ] = useLazyLaunchDemoGameQuery({ prefetch: true });

    useEffect(() => {
        if (!isLaunchDemoGameLoading && !isLaunchDemoGameFetching && isLaunchDemoGameSuccess) {
            if (launchDemoGame?.result?.gameType === "WEB") {
                if (launchDemoGame?.result?.iframeSupported == true) {
                    window.location.href = process.env.REACT_APP_GAME_URL_IFRAME + launchDemoGame.result.gameUrl;
                }
                else {
                    window.open(launchDemoGame.result.gameUrl, "_blank");
                }
            }
        }
    }, [isLaunchDemoGameLoading, isLaunchDemoGameFetching, isLaunchDemoGameSuccess]);

    useEffect(() => {
        if (islaunchDemoGameError) {
            Swal.fire({
                text: launchDemoGameError?.data?.message,
                icon: "error"
            });
        }
    }, [islaunchDemoGameError]);


    const handlePlay = () => {
        setDialogOpen(false);

        navigate({
            pathname: location.pathname,
            search: "?login=1",
        })
    };

    const playDemo = (game) => {
        setDialogData({
            type: 'game',
            game,
            title: game.name,
            image: game.thumbnailUrl,
        });
        setDialogOpen(true);
    };

    const playDemoProvider = (provider, category) => {
        setDialogData({
            type: 'provider',
            provider,
            category,
            title: provider.name,
            image: provider.homeGameImgUrl,
        });
        setDialogOpen(true);
    };

    return {
        playDemo,
        playDemoProvider,
        dialog:
            <Dialog fullWidth={'90%'} open={dialogOpen} onClose={handleDialogClose} keepMounted >
                <DialogContent style={{ padding: mobileView ? "20px 20px" : "20px 30px" }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleDialogClose}
                        sx={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Grid width={'100%'} container alignItems="center" spacing={2}>
                        <Grid xs={6} item>
                            <img
                                src={dialogData?.image}
                                alt="Popup Illustration"
                                style={{ borderRadius: 8, width: "100%", height: '90px' }}
                            />
                        </Grid>
                        <Grid xs={6} item>
                            <Typography color={process.env.REACT_APP_COLOR_INPUTTEXT || 'black'}>
                                {dialogData?.title}
                            </Typography>
                            <Typography style={{ fontSize: 10 }} color={process.env.REACT_APP_COLOR_INPUTTEXT || 'black'}>
                                {dialogData?.type === 'game' ? dialogData?.game?.productCode : dialogData?.provider?.name}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ padding: mobileView ? "auto" : "20px 30px" }}>
                    <Grid container spacing={2} width="100%">
                        <Grid item xs={6}>
                            <Button onClick={handleDemo} variant="contained" fullWidth color="secondary">
                                {t("home.demo")}
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button onClick={handlePlay} variant="contained" fullWidth color="primary">
                                {t("home.playNow")}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog >
    };
};

export default LaunchDemo;
